import { useCallback } from 'react';
import { useAuthFetch } from '@cko/dashboard-shared';

export const useUpdateTimeZoneFetcher = () => {
  const fetch = useAuthFetch();

  return useCallback(
    async ({ path, timeZone }: { path: string; timeZone: string }) => {
      const response = await fetch(path, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          timezone: timeZone,
        }),
      });

      return response.ok;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetch],
  );
};
